import React from 'react';

import Rename from './Rename';
import Move from './Move';
import Group from './Group';

const FileOperation = ({
  file,
  onUpdate,
  onClose,
  selected,
  breadcrumb,
  categoryType,
  userDetails,
  onMove,
  onGroup,
  list,
  companyId,
}) => {
  const renderSections = () => {
    switch (file.type) {
      case 'rename':
        return <Rename file={file} onUpdate={onUpdate} onClose={onClose} />;

      case 'move':
        return (
          <Move
            onClose={onClose}
            selected={selected}
            breadcrumb={breadcrumb}
            categoryType={categoryType}
            userDetails={userDetails}
            onMove={onMove}
            file={file}
            companyId={companyId}
          />
        );

      case 'group':
        return (
          <Group
            onClose={onClose}
            selected={selected}
            breadcrumb={breadcrumb}
            categoryType={categoryType}
            userDetails={userDetails}
            onMove={onGroup}
            file={file}
            list={list}
            companyId={companyId}
          />
        );

      default:
        return null;
    }
  };

  return file ? renderSections() : null;
};

export default FileOperation;
